import { createApp } from 'vue'
import http from './plugins/http';
import Auth from '../components/Auth.vue';

/**
 * Запуск скриптов после инициализации DOM
 */
document.addEventListener('DOMContentLoaded', () => {
    if( document.querySelector('#auth-app') ) {
        const app = createApp( Auth )
        app.use(http)
        app.mount('#auth-app')
    }
});